module.exports = __webpack_public_path__ + "static/media/promo-barhat-seaon.ac8f8459.jpg";